<template>
  <div class="success display-flex justify-center align-center gap-4 pa-4">
    <div class="text-white font-32 font-weight-500">Success!</div>
    <div class="text-white font-22 font-weight-500">
      Welcome to the community
    </div>
    <div class="text-white font-24 font-weight-500">Loud Pack</div>
    <div>
      <img src="../../../../assets/mobile/success.gif" :width="400" />
    </div>
    <v-btn
      class="btn-go mx-0 mt-4 full-width"
      @click="$router.push('/communitym')"
    >
      Go to community
    </v-btn>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.success {
  background: linear-gradient(
    180deg,
    #380095 0%,
    #74b 34%,
    #74b 66%,
    #4444bc 100%
  );
  min-height: 100vh;
  flex-direction: column;
}
.btn-go {
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  line-height: 19px;
  height: 40px;
  border-radius: 60px;
  background: rgba(255, 255, 255, 0.2) !important;
}
</style>



// WEBPACK FOOTER //
// success.vue?722e9895